export const CUSTOM_INPUTS_FIELD_GAP = 12;

export function buildCustomInputPages({
  fieldHeights = [],
  availableHeight = 0,
  gap = CUSTOM_INPUTS_FIELD_GAP,
}) {
  if (!Array.isArray(fieldHeights) || fieldHeights.length === 0) {
    return [];
  }

  if (!availableHeight || availableHeight <= 0) {
    return [fieldHeights.map((_, index) => index)];
  }

  const pages = [];
  let currentPage = [];
  let currentHeight = 0;

  fieldHeights.forEach((rawHeight, index) => {
    const fieldHeight = Math.max(Number(rawHeight) || 0, 1);
    const projectedHeight =
      currentPage.length === 0 ? fieldHeight : currentHeight + gap + fieldHeight;

    if (currentPage.length > 0 && projectedHeight > availableHeight) {
      pages.push(currentPage);
      currentPage = [index];
      currentHeight = fieldHeight;
      return;
    }

    currentPage.push(index);
    currentHeight = projectedHeight;
  });

  if (currentPage.length > 0) {
    pages.push(currentPage);
  }

  return pages;
}

export function findCustomInputPageIndex(pages = [], fieldIndex) {
  if (!Array.isArray(pages) || pages.length === 0) {
    return 0;
  }

  const matchingPageIndex = pages.findIndex((page) => page.includes(fieldIndex));
  return matchingPageIndex >= 0 ? matchingPageIndex : 0;
}

export function areCustomInputPagesEqual(leftPages = [], rightPages = []) {
  if (leftPages.length !== rightPages.length) {
    return false;
  }

  return leftPages.every((page, pageIndex) => {
    const otherPage = rightPages[pageIndex] || [];

    if (page.length !== otherPage.length) {
      return false;
    }

    return page.every((fieldIndex, fieldPosition) => fieldIndex === otherPage[fieldPosition]);
  });
}
